export const REGISTER_ENDPOINT = `/auth/register`;
export const LOGIN_ENDPOINT = `/auth/login`;
export const GET_TASKS = `/tasks`;
export const CREATE_TASKS = `/tasks/create`;
export const UPDATE_TASKS = `tasks/update`;
export const DELETE_TASKS = `tasks/delete`;
export const SIGNOUT = `/signout`
